"use client";
import React from "react";
import { createPortal } from "react-dom";
import { Box } from "@mui/material";
import Image from "next/image";
import Logo from "../../../assets/salontym_loder.png";
import "./index.css";

const overlaySx = {
  position: "fixed" as const,
  inset: 0,
  zIndex: 14000,
  minHeight: "100dvh",
  width: "100%",
  background: "#00000089",
};

export const Loader = () => {
  const [mounted, setMounted] = React.useState(false);
  React.useEffect(() => {
    setMounted(true);
  }, []);

  const content = (
    <Box sx={overlaySx}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          margin: "auto",
          textAlign: "center",
          width: "20%",
        }}
      >
        <Box className="loader-animation"></Box>
        <Image
          src={Logo}
          alt="Logo"
          style={{
            width: "80px",
            paddingBottom: "16px",
            margin: "auto",
            height: "auto",
          }}
          height={200}
          width={200}
          className="loader-image"
          loading="lazy"
        />
      </Box>
    </Box>
  );

  if (!mounted) return null;
  return createPortal(content, document.body);
};
